import React, { useState } from 'react';
import type { ActiveBillingCycleItem } from '../../services/api/types.gen';
import ClaimWorksheetEditor from './ClaimWorksheetEditor';
import { ClaimWorksheetActionButton } from './ClaimWorksheetActionButton';
import { terminalWorksheetViewStatuses } from './worksheet/worksheetUtils';

export const ClaimWorksheetViewerAction: React.FC<{
  billingCycle: ActiveBillingCycleItem;
  /**
   * Runs after an in-editor approval moves the cycle to ready-to-send, so
   * the owning tab can reload its rows and counts (the cycle leaves the
   * tab it was listed under).
   */
  onApproved?: () => void | Promise<void>;
}> = ({ billingCycle, onApproved }) => {
  const [open, setOpen] = useState(false);
  const terminal = terminalWorksheetViewStatuses.has(
    billingCycle.billing_cycle_status
  );
  return (
    <>
      <ClaimWorksheetActionButton
        onClick={() => setOpen(true)}
        label={terminal ? 'View claim worksheet' : 'Edit claim worksheet'}
      />
      {open && (
        <ClaimWorksheetEditor
          billingCycle={billingCycle}
          readOnly={terminal}
          onClose={() => setOpen(false)}
          onApproved={onApproved}
        />
      )}
    </>
  );
};
